export default "__VITE_ASSET__BRDLd0wv__"